module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"copiar":"Copiar","boton_copiar":"Copiar enlace","enlace_copiado":"Enlace copiado al portapaleles","compartir":"Compartir"}}')
  delete Component.options._Ctor
}
